<template>
  <bronze-token-small v-if="type === 'bronze'" :class="classes"></bronze-token-small>
  <silver-token-small v-else-if="type === 'silver'" :class="classes"></silver-token-small>
  <orange-token-small v-else-if="type === 'orange'" :class="classes"></orange-token-small>
</template>

<script>

import BronzeTokenSmall from './BronzeTokenSmall';
import OrangeTokenSmall from './OrangeTokenSmall';
import SilverTokenSmall from './SilverTokenSmall';

export default {
  props: {
    type: String,
    hasShadow: Boolean
  },
  computed: {
    classes() {
      return this.hasShadow ? 'has-shadow' : '';
    }
  },
  components: {BronzeTokenSmall, OrangeTokenSmall, SilverTokenSmall}
};
</script>
<style lang="scss" scoped>
* {
  border-radius: 50%;
}
.has-shadow {
  box-shadow: 0 0 5px var(--secondary-mid-opacity);
}
</style>
